import axiosClient from '@clients/axiosClient';

type IAccountSearchCRM = {
    query: string;
};

export type SearchResult = {
    account_id: number;
    customer_id: number;
    name: string;
    last_4_digits: string;
    program_name: string;
    email: string;
    financial_status: string;
    due_date_days: string | null;
    program_type: string;
    last_card_id: number;
    token: string;
    is_owner: number;
    document_number: string;
};

const crm = () => {
    const client = axiosClient();

    return {
        async accountSearchCRM({ query }: IAccountSearchCRM) {
            const { data } = await client.get<SearchResult[]>(
                `/crm/v1/customers/find/${query}`,
            );
            return data;
        },
    };
};

export default crm;
